export { default } from './AuthController'
